var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-product" }),
        _vm._v(_vm._s(_vm.$t("Update Records")) + " ")
      ]),
      _c(
        "div",
        { staticClass: "searchArea" },
        [
          _c("v-text-field", {
            staticClass: "form-input ml-3",
            attrs: {
              outlined: "",
              dense: "",
              "hide-details": "",
              label: _vm.$t("File Name"),
              placeholder: _vm.$t("Input File Name"),
              clearable: ""
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.searchRecords($event)
              }
            },
            model: {
              value: _vm.searchBy.fileName,
              callback: function($$v) {
                _vm.$set(_vm.searchBy, "fileName", $$v)
              },
              expression: "searchBy.fileName"
            }
          }),
          _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": "",
                "min-width": "290px"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-text-field",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "form-input ml-3",
                              attrs: {
                                value: _vm.searchBy.startDate,
                                label: "" + _vm.$t("Period"),
                                placeholder: "" + _vm.$t("Select start date"),
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                readonly: "",
                                clearable: ""
                              },
                              on: {
                                "click:clear": function($event) {
                                  return _vm.clearDate(
                                    _vm.searchBy,
                                    "startDate"
                                  )
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            width: "16",
                                            height: "16",
                                            src: require("@/assets/img/ico-calendar.png")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            "v-text-field",
                            attrs,
                            false
                          ),
                          on
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.showStartDatePicker,
                callback: function($$v) {
                  _vm.showStartDatePicker = $$v
                },
                expression: "showStartDatePicker"
              }
            },
            [
              _c("v-date-picker", {
                attrs: { "no-title": "" },
                on: {
                  change: _vm.checkStartDate,
                  input: function($event) {
                    _vm.showStartDatePicker = false
                  }
                },
                model: {
                  value: _vm.searchBy.startDate,
                  callback: function($$v) {
                    _vm.$set(_vm.searchBy, "startDate", $$v)
                  },
                  expression: "searchBy.startDate"
                }
              })
            ],
            1
          ),
          _c("span", { staticClass: "ml-1 mr-1" }, [_vm._v("~")]),
          _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": "",
                "min-width": "290px"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-text-field",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "form-input",
                              attrs: {
                                value: _vm.searchBy.endDate,
                                placeholder: "" + _vm.$t("Select end date"),
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                solo: "",
                                readonly: "",
                                clearable: ""
                              },
                              on: {
                                "click:clear": function($event) {
                                  return _vm.clearDate(_vm.searchBy, "endDate")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        _c("img", {
                                          attrs: {
                                            width: "16",
                                            height: "16",
                                            src: require("@/assets/img/ico-calendar.png")
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            "v-text-field",
                            attrs,
                            false
                          ),
                          on
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.showEndDatePicker,
                callback: function($$v) {
                  _vm.showEndDatePicker = $$v
                },
                expression: "showEndDatePicker"
              }
            },
            [
              _c("v-date-picker", {
                attrs: { "no-title": "" },
                on: {
                  change: _vm.checkEndDate,
                  input: function($event) {
                    _vm.showEndDatePicker = false
                  }
                },
                model: {
                  value: _vm.searchBy.endDate,
                  callback: function($$v) {
                    _vm.$set(_vm.searchBy, "endDate", $$v)
                  },
                  expression: "searchBy.endDate"
                }
              })
            ],
            1
          ),
          _c(
            "v-btn",
            {
              staticClass: "btn type-search ml-3",
              attrs: { text: "" },
              on: { click: _vm.searchRecords }
            },
            [_vm._v(_vm._s(_vm.$t("Search")))]
          )
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          staticClass: "tbl-type01 mt-10",
          attrs: {
            "item-key": "id",
            headers: _vm.recordHeaders,
            items: _vm.tableItems,
            page: _vm.page,
            "hide-default-footer": true,
            options: _vm.options,
            "server-items-length": _vm.totalRecords
          },
          on: {
            "update:page": function($event) {
              _vm.page = $event
            },
            "update:options": function($event) {
              _vm.options = $event
            }
          }
        },
        [
          _c("template", { slot: "no-data" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")])
          ])
        ],
        2
      ),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "btn",
                attrs: { disabled: _vm.exportDisabled, text: "" },
                on: { click: _vm.exportRecords }
              },
              [_vm._v(_vm._s(_vm.$t("Export")))]
            )
          ],
          1
        ),
        _c("div", { staticClass: "pageInfo" }, [
          _vm._v(_vm._s(_vm.pageInfoText))
        ]),
        _c(
          "div",
          [
            _c("v-pagination", {
              staticStyle: { float: "right" },
              attrs: {
                length: _vm.totalPages * 1,
                "total-visible": _vm.totalVisiblePages,
                color: "#2f3b4c"
              },
              on: { input: _vm.paging },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]),
      _c("a", { ref: "link", style: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }